import {AnyAction} from 'redux';
import {ThunkAction, ThunkDispatch} from 'redux-thunk';
import {AppState} from '../../../store';
import {xhrHelper} from '../../../utils/xhrHelper';
import axios from 'axios';
// import {ISET_QNA_DATA} from './types.js';

import {
  ISnapData,
  UPDATE_HASDATA,
  SET_SNAP_DATA,
  UPDATE_HASREVIEWDATA,
  SET_USER_REVIEWS,
  UPDATE_REVIEW_DETAILS,
  UPDATE_PAGINATOR_STATUS,
  SET_QNA_FILTER,
  SET_QNA_DATA,
  UPDATE_QNA_DETAILS,
  UPDATE_QNAPAGINATOR_STATUS,
  UPDATE_QNA_TAGS,
  UPDATE_NEW_QUESTIONS,
  PostAnswerType,
  SET_REVIEW_DATA_STATUS,
  SET_QNA_DATA_STATUS,
  UPDATE_HAS_QNADATA,
  SET_MORE_IMAGES,
  UPDATE_HAS_MOREIMAGES,
  SELECTED_RNR_TYPE,
  UPDATE_RNR_TAGS,
} from './types';

export function setSnapDataAction(actionData: ISnapData['snapData']) {
  return {
    type: SET_SNAP_DATA,
    actionData,
  };
}

export function updateHasDataAction(actionData: ISnapData['hasData']) {
  return {
    type: UPDATE_HASDATA,
    actionData,
  };
}

export function updateHasQnaDataAction(actionData: ISnapData['hasQnaData']) {
  return {
    type: UPDATE_HAS_QNADATA,
    actionData,
  };
}

export function updateNewQuestions(actionData: ISnapData['newQuestions']) {
  return {
    type: UPDATE_NEW_QUESTIONS,
    actionData,
  };
}

export function updateReviewDataStatus(actionData: ISnapData['pendingReviewData']) {
  return {
    type: SET_REVIEW_DATA_STATUS,
    actionData,
  };
}

export function updateQnaDataStatus(actionData: ISnapData['pendingQnaData']) {
  return {
    type: SET_QNA_DATA_STATUS,
    actionData,
  };
}

export function updateHasUserReview(actionData: ISnapData['hasReviewData']) {
  return {
    type: UPDATE_HASREVIEWDATA,
    actionData,
  };
}

export function updateUserReview(actionData: ISnapData['reviewData']) {
  return {
    type: SET_USER_REVIEWS,
    actionData,
  };
}

export function userReviewDetailType(actionData: ISnapData['reviewDetailType']) {
  return {
    type: UPDATE_REVIEW_DETAILS,
    actionData,
  };
}

export function userQnaDetailType(actionData: ISnapData['qnaDetailType']) {
  return {
    type: UPDATE_QNA_DETAILS,
    actionData,
  };
}

export function updateMoreImages(actionData: ISnapData['moreUgcImages']) {
  return {
    type: SET_MORE_IMAGES,
    actionData,
  };
}

export function updateHasMoreImages(actionData: ISnapData['hasMoreImages']) {
  return {
    type: UPDATE_HAS_MOREIMAGES,
    actionData,
  };
}

export function updatePaginatorStatus(actionData: ISnapData['paginatorStatus']) {
  return {
    type: UPDATE_PAGINATOR_STATUS,
    actionData,
  };
}

export function updateQnaPaginatorStatus(actionData: ISnapData['qnaPaginatorStatus']) {
  return {
    type: UPDATE_QNAPAGINATOR_STATUS,
    actionData,
  };
}

export function setQNAFilters(actionData: ISnapData['qnaFilterData']) {
  return {
    type: SET_QNA_FILTER,
    actionData,
  };
}

export function updateQnaTags(actionData: ISnapData['selTagIds']) {
  return {
    type: UPDATE_QNA_TAGS,
    actionData,
  };
}

export function updateRnrTags(actionData: ISnapData['selRnrTagIds']) {
  return {
    type: UPDATE_RNR_TAGS,
    actionData,
  };
}

export function setQNAData(actionData: ISnapData['qnaData']) {
  return {
    type: SET_QNA_DATA,
    actionData,
  };
}

export function updateSelectedRnrType(actionData: ISnapData['selectedRnRType']) {
  return {
    type: SELECTED_RNR_TYPE,
    actionData,
  };
}

export function reaskQuestion({questionId}, cb) {
  const url = 'https://ugc.goibibo.com/api/Questions/' + questionId + '/reaskQuestion';
  axios
    .post(url, {}, {withCredentials: true})
    .then(response => {
      if (response && response.data.status === 'success') {
        return cb({status: 'success'});
      } else if (response && response.data.status === 'fail') {
        return cb({status: 'fail', msg: response.data.error.message});
      }
      return cb(null);
    })
    .catch(err => {
      console.log('Reask Question API Call Failed', err.error);
      console.trace(err);
      return cb(null);
    });
}

export function postAnswer({questionId, answerObj}, cb) {
  const url = 'https://ugc.goibibo.com/api/Answers/' + questionId + '/postAnswer';
  axios
    .post(url, answerObj, {withCredentials: true})
    .then(response => {
      if (response && response.status === 200) {
        return cb(response.data as PostAnswerType);
      }
      return cb(null);
    })
    .catch(err => {
      console.log('Post Answer API Call Failed', err.error);
      console.trace(err);
      return cb(null);
    });
}

export function postQuestion({questionObj}, cb) {
  const url = 'https://ugc.goibibo.com/api/Questions';
  axios
    .post(url, questionObj, {withCredentials: true})
    .then(response => {
      if (response && response.status === 200) {
        return cb(response.data);
      }
      return cb(null);
    })
    .catch(err => {
      console.log('Post Qna API Call Failed', err.Error);
      console.trace(err);
      return cb(null);
    });
}
